import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'CTLConfirm',
            headers: {},
            args: {
                ...payload,
            },
            urlArgs: {},
        });
        return result;
    };
};
